import { render } from "./Upload.vue?vue&type=template&id=5da48b0e"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/icons/Upload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5da48b0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5da48b0e', __exports__)) {
    api.reload('5da48b0e', __exports__)
  }
  
  module.hot.accept("./Upload.vue?vue&type=template&id=5da48b0e", () => {
    api.rerender('5da48b0e', render)
  })

}


export default __exports__